const SUIT_MAP = {
  S: 'spades',
  H: 'hearts',
  D: 'diamonds',
  C: 'clubs',
};

/**
 * @param {string | null | undefined} str e.g. "AH", "10S", "TC"
 * @returns {{ suit: string, rank: string } | null}
 */
export function parseSekaCard(str) {
  if (!str || typeof str !== 'string') return null;
  const upper = str.trim().toUpperCase();
  const last = upper.slice(-1);
  const suit = SUIT_MAP[last];
  if (!suit) return null;
  let rank = upper.slice(0, -1);
  if (rank === 'T') rank = '10';
  return { suit, rank };
}
